import React, { useEffect } from "react";
import Box from "@mui/joy/Box";
import Grid from "@mui/joy/Grid";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import CardCover, { cardCoverClasses } from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import HandshakeIcon from "@mui/icons-material/Handshake";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/joy/IconButton";
import HikingIcon from "@mui/icons-material/Hiking";
import Popup from "./popup";
import axios from "axios";

export default function Tarjeta() {
  let [usuarios, setUsuarios] = React.useState({ usuariosmatch: [] });
  let [posicion, setPosicion] = React.useState(0);
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;
  let logo = url + "/uploads/logo.svg";

  /* LIKE A USUARIOS */

  let meGustas = async () => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */
      let postMegusta = await axios.post(
        `${url}/api/amigos`,
        { id: usuarios.usuariosmatch[posicion].id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.log("No fué posible enviar el me gustas al servidor: " + err);
    }
  };

  /* LIKE A USUARIOS */

  /* NO ME GUSTAS */

  let noMegustas = async () => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */
      let noMegusta = await axios.post(
        `${url}/api/rechazar`,
        { id: usuarios.usuariosmatch[posicion].id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.log("No fué posible enviar el me gustas al servidor: " + err);
    }
  };

  /* NO ME GUSTAS */

  /* OBTENER USUARIOS */

  useEffect(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let infoUsuarios = async () => {
        let getUsuarios = await axios.get(`${url}/api/usuarios`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsuarios(getUsuarios.data[0]);
        /* console.log(getUsuarios.data[0]); */
      };
      infoUsuarios();
    } catch (err) {
      console.log("Tenemos un error al recoger usuarios: " + err);
    }
  }, []);

  /* OBTENER USUARIOS */

  /* CALCULAR EDAD*/

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      return edad - 1;
    }
    return edad;
  };

  /* CALCULAR EDAD*/

  let [estadoPopup, setEstadoPopup] = React.useState(false);

  let tarjeta = () => {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Popup
          edad={
            usuarios.usuariosmatch
              ? calcularEdad(
                  usuarios.usuariosmatch[posicion].fecha_de_nacimiento
                )
              : null
          }
          perfil={
            usuarios.usuariosmatch ? usuarios.usuariosmatch[posicion] : null
          }
          estado={estadoPopup}
          cerrar={() => {
            setEstadoPopup(false);
          }}
        />
        <Card sx={{ width: 320 }}>
          <CardOverflow
            onClick={() => {
              /*     console.log("hola"); */
              /*    console.log(estadoPopup); */
              setEstadoPopup(true);
            }}
            sx={{ cursor: "pointer" }}
          >
            <AspectRatio ratio={0.8}>
              <img
                src={
                  usuarios.usuariosmatch
                    ? `${linkimagen}/uploads/` +
                      usuarios.usuariosmatch[posicion].foto_de_perfil
                    : null
                }
                alt=""
                loading="lazy"
              />
            </AspectRatio>
          </CardOverflow>

          <CardContent>
            <Typography level="title-lg">
              {usuarios.usuariosmatch
                ? usuarios.usuariosmatch[posicion].nombre + ", "
                : null}
              {usuarios.usuariosmatch
                ? calcularEdad(
                    usuarios.usuariosmatch[posicion].fecha_de_nacimiento
                  ) + " "
                : null}
              años
            </Typography>
            <Typography level="body-sm">
              {usuarios.usuariosmatch
                ? usuarios.usuariosmatch[posicion].intereses[0]
                : null}
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Grid container spacing={1}>
                {usuarios.usuariosmatch
                  ? usuarios.usuariosmatch[posicion].actividades.map((x) => {
                      return (
                        <Grid key={x.id}>
                          <Chip size="sm" sx={{ backgroundColor: "#EFE3C2" }}>
                            {x}
                          </Chip>
                        </Grid>
                      );
                    })
                  : null}
              </Grid>
            </Box>
          </CardContent>
          <CardContent sx={{ marginTop: "1rem" }}>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid>
                <IconButton
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <CloseIcon
                    sx={{ fontSize: 40, color: "#D32F2F" }}
                    onClick={() => {
                      noMegustas();
                      setPosicion(posicion + 1);
                    }}
                  />
                </IconButton>
              </Grid>
              <Grid>
                <IconButton
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <HandshakeIcon
                    sx={{ fontSize: 40, color: "#123524" }}
                    onClick={() => {
                      meGustas();
                      setPosicion(posicion + 1);
                    }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    );
  };

  let noUsuarios = () => {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "grid",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
          }}
        >
          <AspectRatio
            variant="plain"
            ratio="1"
            sx={{
              width: "150px",
              marginBottom: "2rem",
              borderRadius: "12px",
            }}
          >
            <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
          </AspectRatio>
          <Typography level="body-sm" endDecorator={<HikingIcon />}>
            Vuelve pronto para más compañeros
          </Typography>
        </Box>
      </Box>
    );
  };
  if (posicion === usuarios.usuariosmatch.length) {
    return noUsuarios();
  } else {
    return tarjeta();
  }
}
